import _slicedToArray from 'babel-runtime/helpers/slicedToArray';
import { useState, useEffect, useRef } from 'react';

var useFetch = function useFetch(url) {
  var _useState = useState({}),
      _useState2 = _slicedToArray(_useState, 2),
      fetchData = _useState2[0],
      setFetchData = _useState2[1];

  var isMounted = useRef(false);

  useEffect(function () {
    isMounted.current = true;
    fetch(url)
    // We get the API response and receive data in JSON format...
    .then(function (response) {
      return response.json();
    })
    // ...then we update the filterData state
    .then(function (data) {
      if (isMounted.current === true) setFetchData(data);
    })
    // Catch any errors we hit and update the app
    // eslint-disable-next-line no-console
    .catch(function (error) {
      return console.log(error);
    });
    return function () {
      isMounted.current = false;
    };
  }, [url]);

  return fetchData;
};

export default useFetch;